export default "__VITE_ASSET__455808bf__"